var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExit = function SvgIconExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.951 0a.87.87 0 0 1 .697.352.87.87 0 0 1 .352.697v19.58a.87.87 0 0 1-.352.697.87.87 0 0 1-.697.352H8.566a.87.87 0 0 1-.697-.352.87.87 0 0 1-.352-.697v-5.594a.874.874 0 1 1 1.749 0v4.895h13.986V1.748H9.266v4.895a.874.874 0 1 1-1.749 0V1.05A.87.87 0 0 1 7.87.352.87.87 0 0 1 8.566 0h15.385Zm-9.79 11.538H2.988l2.357 2.357a.874.874 0 0 1-1.236 1.236L.256 11.28a.874.874 0 0 1 0-1.236L3.937 6.36a.874.874 0 1 1 1.236 1.236L2.981 9.79h11.18a.874.874 0 0 1 0 1.748Z",
    fill: "#211A6E"
  })));
};
export default SvgIconExit;